import axios from "axios";
import {config} from "../../../../enviroment"

export const registerService={
    register
}
async function register(data) {
    let APIquery={};
    if(!data.FLNameRequired){
      APIquery={
        password: data.password,
        email: data.emailId,
        phoneNumber: data.mobileNo,
        userName: data.mobileNo,
        identities: [
          {
            identityValue: data.accountNo,
            identityCode: data.tenantIdNo,
          },
        ],
        tenantCode: config.parameters.TENANT_CODE,
        createdBy: 0,
      };
    }else{
      APIquery={
        firstName: data.firstName,
        lastName: data.lastName,
        password: data.password,
        email: data.emailId,
        userName: data.accountNo,
        phoneNumber: data.country_Calling_Code_backend + data.mobileNo,
        identities: [
          {
            identityValue: data.accountNo,
            identityCode: data.tenantIdNo,
          },
        ],
        tenantCode: config.parameters.TENANT_CODE,
        createdBy: 0,
      };
    }
    return await axios.post(config.urls.SIGNUP, APIquery);
  }